<template>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title
                >{{ $route.params.campaignId === "new" ? t("Add new") : activeCampaign.name }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ t("Save") }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ t(item) }}
            </v-tab>
            <v-tab-item>
                <general-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import GeneralEditTab from "./campaign-tab-items/general-edit-tab";

export default {
    name: "campaign-edit",
    components: { GeneralEditTab },

    data() {
        return {
            tab: 0,
            tabs: ["General"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.campaignId === "new") {
            await this.addNewCampaign();
        } else {
            await this.getCampaignData(this.$route.params.campaignId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("CampaignStore", ["activeCampaign", "errorMessage", "requestSuccess"])
    },
    watch: {
        requestSuccess(val) {
            if (val === true) {
                this.$router.push({
                    name: "campaign-list"
                });
            }
        }
    },
    methods: {
        ...mapMutations("CampaignStore", ["addNewCampaign"]),
        ...mapActions("CampaignStore", ["submitCampaignUpdate", "getCampaignData"]),
        closeDrawer() {
            this.$router.push({ name: "campaign-list" });
        },
        async submitEdit() {
            await this.submitCampaignUpdate(this.activeCampaign);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        }
    }
};
</script>

<style scoped></style>
